// src/Pages/Landing/JoyrideMikkeliLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideMikkeliLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Mikkeli"
      maakunta="Etelä-Savo"
      nearbyAreas={[
        "Savonlinna",
        "Pieksämäki",
        "Juva",
        "Mäntyharju",
        "Puumala",
        "Kangasniemi"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Mikkelissä ja Etelä-Savon alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Mikkeli sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Mikkelin keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}